import React from "react";

import "./ChatMessage.scss";

interface ChatMessageProps {
  avatar: string;
  message: string;
  username?: string;
}

const ChatMessage: React.FC<ChatMessageProps> = ({
  avatar,
  message,
  username,
}) => {
  const isMentioned = !!username;

  return (
    <div className="chat-message">
      <div
        className="avatar-box"
        style={{ background: isMentioned ? undefined : "#f8d8c1" }}
      >
        <img src={avatar} alt="avatar" className="avatar" />
      </div>
      <div className={`bubble ${isMentioned ? "mention" : ""}`}>
        {isMentioned ? (
          <>
            <span className="mention-tag">@{username}</span>, {message}
          </>
        ) : (
          message
        )}
      </div>
    </div>
  );
};

export default ChatMessage;
